import {
  toRequestFormApplicantSelectOption,
  useCreateRequest,
} from '../../../Request'
import { EMAIL_TABLE_ROW_ACTIONS_CONFIG } from '../../Email.constants'
import { getEmailServiceRequestCreationInitialValues } from '../../Email.utils'

export function useEmailCreateRequestAction({
  minimizedModalScope,
  onSuccess,
}) {
  const { handleOpenCreation, requestCreationModal } = useCreateRequest({
    minimizedModalScope,
  })

  function handleOpenRequestCreationModal(item) {
    handleOpenCreation({
      formProps: {
        initialValues: getEmailServiceRequestCreationInitialValues(item),
        onSuccess,
      },
      wizardProps: {
        initialUser: toRequestFormApplicantSelectOption(item.owner),
        messageUuid: item[EMAIL_TABLE_ROW_ACTIONS_CONFIG.itemIdKey],
        onSuccess,
      },
    })
  }

  return {
    handleOpenRequestCreationModal,
    requestCreationModal,
  }
}
